import { render, staticRenderFns } from "./FlockPnl.vue?vue&type=template&id=0e5d2cbc&scoped=true&"
import script from "./FlockPnl.vue?vue&type=script&lang=js&"
export * from "./FlockPnl.vue?vue&type=script&lang=js&"
import style0 from "./FlockPnl.vue?vue&type=style&index=0&id=0e5d2cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d2cbc",
  null
  
)

export default component.exports